<div class="container component">
    <div class="list">
        <div class="shipmentItem" *ngFor="let item of shipments" (click)="selectShipment(item)"
            [ngClass]="{'selected': selectedShipment && item.shipmentId==selectedShipment.shipmentId}">
            <shared-shipment-item [shipment]="item" [isActiveRoutes]="true"></shared-shipment-item>
        </div>
    </div>

    <div class="wide-column" *ngIf="selectedShipment">
        <shared-shipment-item-maintenance [shipment]="selectedShipment" [routeId]="routeId" [readonly]="readonly"
            (refreshShipment)="onRefreshShipment($event)">
        </shared-shipment-item-maintenance>
    </div>
</div>
